





















































































































































































































































































































































import { Component, Vue, Watch, Inject } from 'vue-property-decorator';
import {
  DropDownController,
  ConsultController,
  AccessLogController,
  ActivityController,
  LoginController,
  WechatController,
  SchoolController,
} from '@/services/request.service';
import LocationCascader from '@/components/LocationCascader.vue';
import { DropDownResponse } from '@/services/__model';
import { fixIOSScroll, getSchoolInfo, isWechat } from '@/utils/utils';
import { initWechat, wechatReady } from '@/utils/wechat';
import config from '@/school.config';
import moment, { Moment } from 'moment';
import { MenuItemGroup } from 'ant-design-vue/types/menu/menu-item-group';
import { Option } from 'ant-design-vue/types/select/option';

const env: string = process.env.VUE_APP_ENV as string;

@Component({
  components: {
    LocationCascader,
  },
})
export default class Enquiry extends Vue {
  @Inject() public readonly reloadPage!: any;
  public provinceList: Array<DropDownResponse> = [];
  public districtList: Array<DropDownResponse> = [];
  public gradeList: Array<DropDownResponse> = [];
  public cityList: Array<DropDownResponse> = [];
  public visitList: Array<DropDownResponse> = [];
  public getSourceList: Array<DropDownResponse> = [];
  public status: string = 'noStart'; // fill || submit || noStart || end || error || loading
  public formLayout = 'horizontal';
  public loading: boolean = false;
  public activityInfo: any = {};
  public verifyCodeTimer = 0;
  public verifyLoading = false;
  // public openid: string = '';
  public addressStatus: string = '';
  public address: Array<any> = [];
  public consultSchoolYearAndSemesterList: Array<any> = [];
  public newConsultSchoolYearAndSemesterList: Array<any> = [];
  public enquiryForm: any;
  public fixIOSScroll = fixIOSScroll;
  public moment = moment;
  public config = config;
  public date = '';
  public age: number = 0;
  public code: string = '';
  public visitTimeAvailable: string = 'available';
  public activityChannelId: number = 0;
  public data: any = {};
  public sourceIsOther: boolean = false;
  public isAgeInvalid: boolean = false;
  public campusType: number = -1;
  public studentList: any = [];
  public newData: any = {};
  public isSource: boolean = false;
  public logoUrl: any = '';
  public schoolName: any = '';
  public get fieldNames() {
    return { label: 'value', value: 'key', children: 'children' };
  }
  public get fields() {
    return this.activityInfo.formFields.filter((item: any) => item.selectedFlag).map((item: any) => item.property);
  }
  public onDateOfBirthChange(date: any, dateString: string) {
    if (date) {
      this.setAge(date);
      const year = this.enquiryForm.getFieldValue('schoolYearId');
      this.isAgeInvalid = false;
      this.campusType = -1;
      this.enquiryForm.setFieldsValue({ sectionId: undefined });
    } else {
      this.isAgeInvalid = false;
      this.campusType = -1;
      this.enquiryForm.setFieldsValue({ sectionId: undefined, campusId: undefined });
    }
  }
  public sourceChange() {}
  public setAge(birthday: any): void {
    let age = moment().year() - birthday.year();
    if (birthday.isBefore(birthday.year() + '-09-01')) {
      age += 1;
    }
    this.age = age;
  }
  public get school() {
    return getSchoolInfo().shortName;
  }

  public get rules() {
    return {
      name: [{ required: true, message: this.$t('warningTip.valueInvalid'), whitespace: true, min: 1, max: 50 }],
      wxid: [{ required: true, message: this.$t('warningTip.valueInvalid'), whitespace: true, min: 1, max: 50 }],
      mobile: [{ required: true, message: this.$t('warningTip.enquiryMobileInvaild'), pattern: /^[0-9]{11}$/ }],
      vcode: [{ required: true, message: this.$t('login.enterVerifyCode') }],
      email: [{ required: true, message: this.$tc('pleaseEnter'), type: 'email' }],
      schoolNowExtra: [{ required: true, message: this.$t('warningTip.valueInvalid'), min: 1, max: 50 }],
      plateNumber: [{ message: this.$t('warningTip.valueNotMoreThen10'), max: 10 }],
    };
  }

  public get isMobile(): boolean {
    const ua = window.navigator.userAgent;
    const isAndroid = /(?:Android)/.test(ua);
    // const isFireFox = /(?:Firefox)/.test(ua);
    // const isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua));
    const isPhone = /(?:iPhone)/.test(ua);
    return isAndroid || isPhone;
  }

  public beforeCreate(): void {
    this.enquiryForm = this.$form.createForm(this);
  }

  public created(): void {
    this.schoolName = getSchoolInfo().shortName;
    // this.getLogo();
    this.$store.dispatch('getSourceList');
    this.activityChannelId = parseInt(this.$route.params.activityChannelId, 10);
    this.getCode();
    if (config[getSchoolInfo().shortName].wechat && isWechat() && !this.openid && !this.code) {
      const appid = config[getSchoolInfo().shortName][env].appid;
      const href = window.location.href;
      const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
        href
      )}&response_type=code&scope=snsapi_base#wechat_redirect`;
      window.location.href = url;
    } else if (config[this.school].wechat && isWechat() && !this.openid && this.code) {
      this.getOpenIdByCode();
    } else if (this.openid || !config[this.school].wechat) {
      this.getInitWechat();
    }
    this.getActivityInfo();
    this.getGradeList();
    this.$store.dispatch('getCountryWithCodeList');
    this.$store.dispatch('getConsultSchoolYearAndSemesterList');
    // console.log(this.$store.state.consultSchoolYearAndSemesterList)
    this.$store.dispatch('getConsultSectionList');
    this.getConsultSchoolYearAndSemesterList();
  }

  @Watch('$route', { immediate: true })
  public refresh(to: any, from: any): void {
    const newId: any = to && to.params && to.params.activityChannelId ? to.params.activityChannelId : null;
    const lastId: any = from && from.params && from.params.activityChannelId ? from.params.activityChannelId : null;
    if (newId && lastId && lastId !== newId) {
      this.reloadPage();
    }
  }
  public getConsultSchoolYearAndSemesterList(): void {
    DropDownController.getSchoolYearAndSemesterList().then(res => {
      this.consultSchoolYearAndSemesterList = res.data;
      this.newConsultSchoolYearAndSemesterList = this.consultSchoolYearAndSemesterList.filter(
        (item: any) => item.extraValue !== 5
      );
    });
  }
  public getLink(activityChannelId: any) {
    let link = `${window.location.origin}/#/${this.school}/enquiry/${activityChannelId}`;
    if (this.$store.state.router.mode !== 'hash') {
      link = `${window.location.origin}/enquiry/${activityChannelId}`;
    }
    return link;
  }
  public getNewConsultSchoolYearAndSemesterList() {
    this.newConsultSchoolYearAndSemesterList = this.consultSchoolYearAndSemesterList.filter(
      (item: any) => item.extraValue !== 5
    );
  }
  public getCode() {
    let searchURL = window.location.search;
    searchURL = searchURL.substring(1, searchURL.length);
    const query = searchURL.split('&').map(item => item.split('='));
    const tmp = query.filter(item => item[0] === 'code');
    this.code = !!tmp.length && tmp[0].length >= 2 ? tmp[0][1] : '';
  }

  @Watch('activityInfo')
  public setWechatReady(newVal: any) {
    if (JSON.stringify(newVal) !== '{}') {
      const icon = require(`@/assets/images/${this.config[this.school].slogo}`);
      const { activityName, description, activityChannelId } = newVal;
      wechatReady(activityName, description, icon, this.getLink(activityChannelId));
    }
  }
  public getOpenIdByCode() {
    WechatController.getAccessToken(this.code).then(res => {
      const wechatInfo = {
        activityChannelId: this.activityChannelId,
        wechatId: res.data.openid,
        expireTime: new Date().getTime() + 24 * 60 * 60 * 1000,
      };
      localStorage.setItem('wechat', JSON.stringify(wechatInfo));
      const url = window.location.origin + window.location.pathname + window.location.hash;
      window.location.href = url;
    });
  }

  public get openid() {
    const openIdString = localStorage.getItem('wechat');
    if (openIdString) {
      const { wechatId, expireTime, activityChannelId } = JSON.parse(openIdString);
      const now = new Date().getTime();
      if (expireTime >= now && activityChannelId === this.activityChannelId) {
        return wechatId;
      } else {
        localStorage.removeItem('wechat');
        return null;
      }
    }
    return null;
  }

  public get sectionList() {
    let valueList = ['G7', 'G8', 'G9'];
    return this.config[this.school].isCourseCenter
      ? this.gradeList.filter((item: any) => valueList.includes(item.enValue))
      : this.gradeList;
  }

  public get consultSectionList() {
    let valueList = ['G7', 'G8', 'G9'];
    return this.config[this.school].isCourseCenter
      ? this.$store.state.consultSectionList.filter((item: any) => valueList.includes(item.enValue))
      : this.$store.state.consultSectionList;
  }

  public getInitWechat() {
    let link = `${window.location.origin}/`;
    if (this.$store.state.router.mode !== 'hash') {
      link = `${window.location.origin}/enquiry/${this.activityChannelId}`;
    }
    initWechat(link);
  }

  public getActivityInfo(): void {
    this.status = 'loading';
    ActivityController.getActivityInfoByActivityChannelId(this.activityChannelId).then(res => {
      this.activityInfo = res && res.data ? res.data : {};
      this.logoUrl = this.activityInfo.logoUrl;
      if (res.data) {
        if (this.activityInfo.deleteFlag) {
          this.status = 'delete';
        } else {
          if (moment().isBefore(moment(this.activityInfo.signUpStartTime))) {
            this.status = 'noStart';
          } else if (moment().isAfter(moment(this.activityInfo.signUpEndTime))) {
            this.status = 'end';
          } else {
            this.status = 'fill';
            this.addAccessLog();
            const mobile = this.$route.query.mobile || '';
            if (mobile) {
              this.$nextTick(() => {
                this.enquiryForm.setFieldsValue({ mobile: mobile });
                this.getParentInfo(mobile as string);
              });
            }
          }
        }
      } else {
        this.status = 'error';
      }
      const temp: any = localStorage.getItem('_rtc');
      const activityInfoList = temp ? JSON.parse(temp) : [];
      const activityList = activityInfoList.map((i: any) => i.activityChannelId);
      if (activityList.length && activityList.includes(this.activityChannelId)) {
        this.status = 'submit';
      }
      if (this.activityInfo.visitTimeFlag && !this.activityInfo.visitTimeBySectionFlag) {
        this.getVisitList(this.activityChannelId, null);
      }
    });
  }
  // public getLogo() {
  //   SchoolController.getAllSchools().then((res: any) => {
  //     if (this.config[this.schoolName].schoolId === 1) {
  //       this.logoUrl = res.data[0].logoUrl;
  //     }
  //     if (this.config[this.schoolName].schoolId === 2) {
  //       this.logoUrl = res.data[1].logoUrl;
  //     }
  //     if (this.config[this.schoolName].schoolId === 3) {
  //       this.logoUrl = res.data[2].logoUrl;
  //     }
  //     if (this.config[this.schoolName].schoolId === 4) {
  //       this.logoUrl = res.data[3].logoUrl;
  //     }
  //     if (this.config[this.schoolName].schoolId === 5) {
  //       this.logoUrl = res.data[4].logoUrl;
  //     }
  //     if (this.config[this.schoolName].schoolId === 6) {
  //       this.logoUrl = res.data[5].logoUrl;
  //     }
  //     if (this.config[this.schoolName].schoolId === 7) {
  //       this.logoUrl = res.data[6].logoUrl;
  //     }
  //     if (this.config[this.schoolName].schoolId === 9) {
  //       this.logoUrl = res.data[7].logoUrl;
  //     }
  //   });
  //   return {};
  // }
  public addAccessLog(): void {
    const accessUri: string = window.location.href.split('?')[0];
    AccessLogController.addAccessLog({ accessUri });
  }

  public getGradeList(): void {
    DropDownController.getSectionList().then(res => {
      this.gradeList = res.data;
    });
  }

  public getVisitList(activityChannelId: any, sectionId: any) {
    DropDownController.getActivityVisitList(activityChannelId, sectionId).then(res => {
      this.visitList = res.data;
      if (!this.visitList.length) {
        this.visitTimeAvailable = 'unavailable';
      } else {
        let remainder = this.visitList.filter(item => item.extraValue.remainder !== 0);
        this.visitTimeAvailable = remainder.length > 0 ? 'available' : 'full';
      }
    });
  }
  public onChange(value) {
    // this.enquiryForm.resetFields();
    this.enquiryForm.setFieldsValue({
      parentName: '',
      name: '',
      birthday: '',
      sourceId: '',
      sourceName: '',
      gender: '',
      currentSectionId: '',
      sectionId: '',
      schoolNowExtra: '',
      plateNumber: '',
      countryId: '',
      schoolYearId: [],
      wxid: '',
      email: '',
      inSchool: '',
      demoClass: '',
      attendance: '',
    });
    this.isSource = false;

    const i = this.studentList.indexOf(value);
    if (i !== -1) {
      if (this.data && this.data[i].sourceId) {
        this.isSource = true;
      } else {
        this.isSource = false;
      }
      this.newData = this.data[i];
      this.address = [this.data[i].provinceCode, this.data[i].cityCode, this.data[i].districtCode];
      this.sourceIsOther = this.config[this.school].showResourceExtraValue.includes(this.data.sourceId) ? true : false;
      if (this.data[i].sectionId) {
        this.changeSectionId(this.data[i].sectionId);
      }
      this.enquiryForm.setFieldsValue({
        parentName: this.data[i].parentName,
        mobile: this.data[i].mobile,
        name: this.data[i].name,
        birthday: this.data[i].birthday,
        sourceId: this.data[i].sourceId,
        sourceName: this.data[i].sourceName,
        gender: this.data[i].gender,
        currentSectionId: this.data[i].currentSectionId === -1 ? '' : this.data[i].currentSectionId,
        sectionId: this.data[i].sectionId === -1 ? '' : this.data[i].sectionId,
        schoolNowExtra: this.data[i].schoolNowExtra,
        plateNumber: this.data[i].plateNumber,
        countryId: this.data[i].countryId,
        schoolYearId: [
          this.data[i].schoolYearId === -1 ? '' : this.data[i].schoolYearId,
          this.data[i].semesterId === -1 ? '' : this.data[i].semesterId,
        ],
        wxid: this.data[i].wxid,
        email: this.data[i].email,
        inSchool: this.data[i].inSchool,
        demoClass: this.data[i].demoClass,
        attendance: this.data[i].attendance,
      });
      this.$nextTick(() => {
        this.enquiryForm.setFieldsValue({
          sourceExtra: this.data[i].sourceExtra,
        });
      });
    }
  }
  public getParentInfo(mobile: string) {
    this.studentList = [];
    this.fixIOSScroll();
    if (!mobile || mobile === this.data.mobile) {
      return;
    }
    ConsultController.getRelateConsults(mobile).then(res => {
      if (!res || !res.data) {
        return;
      }
      this.data = res && res.data ? res.data : {};
      for (var i in this.data) {
        this.studentList.push(this.data[i].name);
      }
    });
  }
  public handleSourceChange(value: any): void {
    this.data.sourceId = value;
    this.$nextTick(() => {
      this.enquiryForm.setFieldsValue({
        sourceExtra: '',
      });
    });
    this.sourceIsOther = this.config[this.school].showResourceExtraValue.includes(value) ? true : false;
  }
  public changeSectionId(value: any): void {
    if (this.activityInfo.visitTimeFlag && this.activityInfo.visitTimeBySectionFlag) {
      this.enquiryForm.setFieldsValue({ activityVisitIds: [] });

      this.getVisitList(this.activityChannelId, value);
    }
  }

  public sendVerifyCode(): void {
    const mobile = this.enquiryForm.getFieldValue('mobile');
    if (mobile) {
      this.verifyLoading = true;
      LoginController.sendVerifyCode(mobile, '86')
        .then((result: any) => {
          if (result) {
            this.$message.success(this.$tc('login.sendVerifyCodeSuccess'));
            this.timerCountDown();
          }
        })
        .finally(() => {
          this.verifyLoading = false;
        });
    }
  }

  public timerCountDown(): void {
    this.verifyCodeTimer = 120;
    const timer = setInterval(() => {
      this.verifyCodeTimer = this.verifyCodeTimer - 1;
      if (this.verifyCodeTimer === 0) {
        clearInterval(timer);
      }
    }, 1000);
  }

  public handleSubmit(e: any) {
    e.preventDefault();
    this.enquiryForm.validateFieldsAndScroll((err: any, values: any) => {
      if (!err && !this.loading) {
        this.loading = true;
        if (this.$route.query.signInDirectFlag) {
          values.signInDirectFlag = true;
        }
        values.activityChannelId = this.activityChannelId;
        values.provinceCode = this.address[0];
        values.cityCode = this.address[1];
        values.districtCode = this.address[2];
        if (values.schoolYearId && values.schoolYearId.length >= 2) {
          values.semesterId = values.schoolYearId[1];
          values.schoolYearId = values.schoolYearId[0];
        }
        if (values.date && values.visitTime) {
          values.visitTime = moment(
            `${moment(values.date).format('YYYY/MM/DD')} ${moment(values.visitTime).format('HH:mm')}:00`
          ).valueOf();
        } else if (values.dateTime) {
          values.visitTime = moment(`${moment(values.dateTime).format('YYYY/MM/DD HH:mm')}:00`).valueOf();
        }
        if (this.openid || this.$route.query.openid) {
          values.openid = this.openid || this.$route.query.openid;
        }
        ConsultController.addConsult(values)
          .then((res: any) => {
            this.status = 'submit';
            if (this.activityInfo.liveType === '4301') {
              const temp: any = localStorage.getItem('_rtc');
              const activityInfoList = temp ? JSON.parse(temp) : [];
              activityInfoList.push({
                consultId: res.data as string,
                activityChannelId: this.activityChannelId,
              });
              localStorage.setItem('_rtc', JSON.stringify(activityInfoList));
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    });
  }

  public jumpToLink(): void {
    // remember template consultant
    const temp: any = localStorage.getItem('_rtc');
    const activityInfoList: any = temp ? JSON.parse(temp) : [];
    const activityList = activityInfoList.filter((i: any) => i.activityChannelId === this.activityChannelId);
    if (activityList.length >= 1) {
      window.location.href = process.env.VUE_APP_REQUEST_URL + 'polyv/watch?consultId=' + activityList[0].consultId;
    }
  }

  public handleAddress(rule: any, value: any, callback: any): void {
    if (!(this.$refs.address as any).checkAddress()) {
      this.addressStatus = 'error';
      callback('error');
      return;
    }
    this.addressStatus = '';
    callback();
  }

  public changeAddress(list: any): void {
    this.address = list;
  }
  public get locale(): string {
    return this.$i18n.locale;
  }
}
